import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';
import defaults from 'lodash/defaults';
import overSome from 'lodash/overSome';
import isBoolean from 'lodash/isBoolean';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import conformsTo from 'lodash/conformsTo';
import isLoader from '@signal/utils/isLoader';
import createReducerHelpers from '@signal/core/createReducerHelpers';
import createSagaHelpers from '@signal/utils/createSagaHelpers';
import { AuthError, FetchError } from '@signal/utils/errors';
import { captureException, LEVELS, TAGS } from '@signal/utils/errorReporting';
import LoadableContext from '../loadable/context';
import withStore from '../withStore';
/**
 * VALIDATION HELPERS
 */

/**
 * callbacks validation
 * {@namespace injectLoaderCallbacksDefinition}
 */

export var CALLBACKS_SHAPE = {
  onLoadSuccess: overSome([isFunction, isNil]),
  onLoadError: overSome([isFunction, isNil])
};
export var defaultCallbacks = {
  onLoadSuccess: noop,
  onLoadError: noop
};

var validateCallbacks = function validateCallbacks(callbacks) {
  defaults(callbacks, defaultCallbacks);
  return conformsTo(callbacks, CALLBACKS_SHAPE);
};
/**
 * options validation
 * {@namespace injectLoaderOptionsDefinition}
 */


export var OPTIONS_SHAPE = {
  shouldLoad: overSome([isFunction, isNil]),
  // @see {@link injectLoaderForwardRefCaveat} for inmportant info
  withRef: overSome([isBoolean, isNil])
};
export var defaultOptions = {
  shouldLoad: function shouldLoad() {
    return true;
  },
  withRef: false
};

var validateOptions = function validateOptions(options) {
  defaults(options, defaultOptions);
  return conformsTo(options, OPTIONS_SHAPE);
};
/**
 * Dynamically injects a loader
 *
 * This hoc injects a loader with the creation of a component. It currently
 * does not handle rendering the component, but simply bootstraps the loader
 * when the component is created.
 *
 * @param {DataLoader} loader - The loader to be injected
 * @param {CallbacksDefinition} [callbacks] - @see {@link injectLoaderCallbackDefinition}
 * @param {OptionsDefinition} [options] - @see {@link injectLoaderOptionsDefinition}
 * @returns {function} - `withLoader` higher-order component
 *
 */


export default (function (loader, callbacks, options) {
  return function (WrappedComponent) {
    // Validate the loader provided
    invariant(isLoader(loader), '(hoc...) injectLoader(): Expected a valid loader'); // Validate the callbacks provided

    callbacks = callbacks == null ? {} : callbacks;
    invariant(validateCallbacks(callbacks), '(hoc...) injectLoader(): Expected valid callbacks'); // Validate the options provided

    options = options == null ? {} : options;
    invariant(validateOptions(options), '(hoc...) injectLoader(): Expected a valid options definition');
    var componentDisplayName = "withLoader(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    /**
     * LoaderInjector
     */

    var LoaderInjector = /*#__PURE__*/function (_React$Component) {
      _inherits(LoaderInjector, _React$Component);

      var _super = _createSuper(LoaderInjector);

      function LoaderInjector() {
        var _this;

        _classCallCheck(this, LoaderInjector);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "state", {
          store: null,
          injectReducer: null,
          injectSaga: null,
          ejectSaga: null,
          dataLoadInitialized: false
        });

        _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$state, injectReducer, injectSaga, ejectSaga, dataLoadInitialized, injectedDependencies, loaderInterface, _options, shouldLoad, _callbacks, onLoadSuccess, onLoadError, response, _tags2, _tags;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$state = _this.state, injectReducer = _this$state.injectReducer, injectSaga = _this$state.injectSaga, ejectSaga = _this$state.ejectSaga, dataLoadInitialized = _this$state.dataLoadInitialized;
                  injectedDependencies = _this.context;
                  loaderInterface = {
                    props: _this.props,
                    injectedDependencies: injectedDependencies,
                    injectReducer: injectReducer,
                    injectSaga: injectSaga,
                    ejectSaga: ejectSaga
                  };
                  _options = options, shouldLoad = _options.shouldLoad;
                  _callbacks = callbacks, onLoadSuccess = _callbacks.onLoadSuccess, onLoadError = _callbacks.onLoadError;

                  if (!(!shouldLoad(_this.props) || dataLoadInitialized)) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt("return");

                case 7:
                  _this.setState({
                    dataLoadInitialized: true
                  });

                  _context.prev = 8;
                  _context.next = 11;
                  return loader(loaderInterface);

                case 11:
                  response = _context.sent;
                  onLoadSuccess(response);
                  _context.next = 24;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](8);
                  onLoadError(_context.t0); // We don't need to report auth errors, as they are expected when session expires, etc.

                  if (!(_context.t0 instanceof AuthError)) {
                    _context.next = 20;
                    break;
                  }

                  return _context.abrupt("return");

                case 20:
                  if (!(_context.t0 instanceof FetchError)) {
                    _context.next = 23;
                    break;
                  }

                  captureException(_context.t0, {
                    level: LEVELS.ERROR,
                    tags: (_tags = {}, _defineProperty(_tags, TAGS.CATEGORY, 'Fetch Data'), _defineProperty(_tags, TAGS.COMPONENT, componentDisplayName), _tags)
                  });
                  return _context.abrupt("return");

                case 23:
                  captureException(_context.t0, {
                    level: LEVELS.FATAL,
                    tags: (_tags2 = {}, _defineProperty(_tags2, TAGS.CATEGORY, 'Data Load'), _defineProperty(_tags2, TAGS.COMPONENT, componentDisplayName), _tags2)
                  });

                case 24:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[8, 15]]);
        })));

        return _this;
      }

      _createClass(LoaderInjector, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.loadData();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.loadData();
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              forwardedRef = _this$props.forwardedRef,
              rest = _objectWithoutProperties(_this$props, ["forwardedRef"]);

          return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
            ref: forwardedRef
          }, rest));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(_ref2, prevState) {
          var store = _ref2.store;

          if (store !== prevState.store) {
            var _createReducerHelpers = createReducerHelpers(store),
                injectReducer = _createReducerHelpers.injectReducer;

            var _createSagaHelpers = createSagaHelpers(store),
                injectSaga = _createSagaHelpers.injectSaga,
                ejectSaga = _createSagaHelpers.ejectSaga;

            return {
              store: store,
              injectReducer: injectReducer,
              injectSaga: injectSaga,
              ejectSaga: ejectSaga
            };
          }

          return null;
        }
      }]);

      return LoaderInjector;
    }(React.Component);

    _defineProperty(LoaderInjector, "contextType", LoadableContext);

    _defineProperty(LoaderInjector, "WrappedComponent", WrappedComponent);

    var LoaderInjectorWithStore = withStore(LoaderInjector);
    /**
     * @name injectLoaderForwardRefCaveat
     * Forwarding refs is currently broken when composing with certain hocs that
     * may not be up-to-date with the withRef api. Namely, the react-redux `connect`
     * hoc fails to compose with `React.withRef`.
     *
     * See {@link https://github.com/reduxjs/react-redux/issues/914#issuecomment-377419348}
     */

    var _options2 = options,
        withRef = _options2.withRef;
    var ComponentToReturn = withRef ? React.forwardedRef(function LoaderInjectorWithRef(props, ref) {
      return /*#__PURE__*/React.createElement(LoaderInjectorWithStore, Object.assign({}, props, {
        forwardedRef: ref
      }));
    }) : LoaderInjectorWithStore;
    ComponentToReturn.displayName = componentDisplayName;
    hoistNonReactStatics(ComponentToReturn, WrappedComponent);
    return ComponentToReturn;
  };
});